import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router';

import TourToday from '../TourToday';

class TodayWidget extends React.Component {
  render() {
    if (this.props.tour.groups.length == 0 || this.props.tour.tour_stops.length == 0) {
      return null;
    }
    const lodgingUrl = `/tours/${this.props.tour.id}/hotels`;
    return (
      <div className="col-sm-4">
        <Panel header="Today">
          <TourToday tour={this.props.tour} />
        </Panel>
      </div>
    );
  }
}
export default TodayWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/TodayWidget.js